import type {
	CurrencyFormat,
	HostToClientMessage,
	MessagePayload,
} from "@rubyplay/effw-connector";
import { extractCurrencyFormat } from "@/shared/parsers/currencyFormat";

export type BetPayload = {
	bet: number;
	currencyFormat?: CurrencyFormat;
};

export function extractNumericBet(value: unknown): number | null {
	const numeric = Number(value);

	if (!Number.isFinite(numeric)) {
		return null;
	}

	if (numeric <= 0) {
		return null;
	}

	return numeric;
}

export function parseBetPayload(source: unknown): BetPayload | null {
	if (!source || typeof source !== "object") {
		return null;
	}

	const candidate = source as {
		bet?: unknown;
		currencyFormat?: unknown;
	};

	const bet = extractNumericBet(candidate.bet);

	if (bet === null) {
		return null;
	}

	return {
		bet,
		currencyFormat: extractCurrencyFormat(candidate.currencyFormat),
	};
}

export function parseBetPayloadFromConfigConnection(
	payload: MessagePayload<HostToClientMessage, "ConfigConnection">
): BetPayload | null {
	return parseBetPayload(payload);
}

export function parseBetPayloadFromBetUpdated(
	payload: MessagePayload<HostToClientMessage, "BetUpdated">
): BetPayload | null {
	return parseBetPayload(payload);
}